<!--
Program: LoadingBar
Author: SDL
Description: Loadingbar Common Component
-->
<template>
  <modal name="loadingbar" :scrollable="false" :click-to-close="false" classes="modal-sm" :height="70" :width="70">
    <div class="spinner-border spinner-border-lg" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'loadingbar',
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/common/control/loadingbar/LoadingBar.vue